import React from "react";

function Heading({content}) {
  return <p className="text-2xl md:text-3xl xl:text-5xl f-f-h text-white2 font-bold xl:leading-48px ">{content}</p>;
}

export default Heading;
